import http from './http'

export default class NavEditApi {
	/**
	 * 获取导航
	 * @param {Object} params
	 * @param {String} params.projId
	 */
	static getProjMenu(params) {
		return http.httpGet('/lavrock/edit/menu', params)
	}
	/**
	 * 导航保存
	 * @param {Object} data
	 * @param {Array} data.menuList
	 * @param {Object} data.param
	 */
	static saveEditMenu(data) {
		return http.httpPost('/lavrock/edit/menu', data)
	}
	/**
	 * 修改页面名称
	 * @param {Object} data 数据
	 */
	static editPageName(data) {
		return http.httpPut('/lavrock/edit/menu', data)
	}
	/**
	 * 获取页面管理展示的数据
	 * @param {*} params
	 */
	static getProjPageNav(params) {
		return http.httpGet('/lavrock/edit/newprojnav', params)
	}
}
